/**
 * @documental
 * @export RichTextEditor
 * @name
 * RichTextEditor
 *
 * See [README.md](./README.md)
 */
import { forwardRef } from "react";

import { withSubComponents } from "../../utilities/withSubComponents";
import { RefComponent } from "../RefComponent";
import type { RTEDefs } from "./RichTextEditorProps";
import { Field } from "./components/Field";
import { Input } from "./components/Input";
import { Loader as Placeholder } from "./components/Loader";

export interface RTEModuleDefs {
  readonly Field: typeof Field;
  readonly Placeholder: typeof Placeholder;
}

export const RichTextEditor = withSubComponents<RefComponent<HTMLDivElement, RTEDefs>, RTEModuleDefs>(
  { Field, Placeholder },
  forwardRef<HTMLDivElement, RTEDefs>(function RichTextEditorComponent(props, ref) {
    return <Input ref={ref} {...props} />;
  }),
);
RichTextEditor.displayName = "crx-rich-text-editor";

export { useRichTextEditorPersistence } from "./hooks/useRichTextEditorPersistence";

export { Display as RichTextDisplay } from "./components/Context";
